<script setup>
	import { ref } from 'vue'

	import VideoCard from "@/components/home/VideoCard.vue";
    import ArticleCard from "@/components/home/ArticleCard.vue";

</script>

<template>
    <section class="tutorial-section">
        <div class="section-header">
            Helpful Tutorials
        </div>

		<div class="separator-line"></div>
        
		<div class="section-description">
            Understand how to further update Indicators Explorer in nuanced ways from our very own Data Scientists!
        </div>
		
		<!-- <div>
			<a class="external-link no-underline" 
				href="https://now.nsf.gov/ncses?id=emp_taxonomy_topic&topic_id=be4983151bfbe210080a64a8624bcbc0&&in_context=true"
				target="_blank"
				>
				<i class="external-link-icon fa-solid fa-arrow-up-right-from-square"></i>
				<span class="external-link-text">View All Resources</span>
			</a>
		</div> -->
        
		<div class="section-subtitle">
            Instructional Videos
        </div>

        <section class="card-section">
			<VideoCard fileName="videoCard1.json" />
			<VideoCard fileName="videoCard2.json" />
			<VideoCard fileName="videoCard3.json" />
			<VideoCard fileName="videoCard4.json" />
        </section>
        
		<div class="section-subtitle">
            Relevant Articles
        </div>
        
		<section class="li-card-section">
			<ArticleCard fileName="articleCard3.json" />
			<ArticleCard fileName="articleCard5.json" />
			<ArticleCard fileName="articleCard2.json" />
			<ArticleCard fileName="articleCard4.json" />
        </section>
    </section>
</template>

<style scoped>
.tutorial-section {
	display: flex;
	padding: var(--spacing-7xl, 6rem) var(--spacing-5xl, 4rem);
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-2xl, 2rem);
	align-self: stretch;	
    background: var(--surface-color-Default);
	/*background: var(--surface-color-IndicatorBlue);*/
}

.section-header {
	color: var(--text-Header);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	align-self: stretch;

	/* Medium/H2 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H2, 3.0625rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H2, 3.75rem); /* 122.449% */
}
.section-subtitle {
    color: var(--text-Header);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	align-self: stretch;

	/* Medium/H2 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H3);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H2, 3.75rem); /* 122.449% */
}

.section-description {
	align-self: stretch;

	color: var(--text-Primary);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */

	max-width: 1200px;
}
.separator-line {
    width: 5rem;
    height: 0.375rem;
    background-color: #005495;
    margin: 0;
}
.card-section {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-evenly;
	gap: 1.25rem;
	/*margin-bottom: -1.8rem;*/
	

	width: 100%;
	background-color:transparent;	
}
.card-section > .card {
  flex: 0 0 calc(40% - 10px);
}
.li-card-section {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-xl, 24px);
	align-self: stretch;
}
.external-link {
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 16px);    
    color: var(--text-Header);
    font-size: var(--font-size-Base);
    font-weight: var(--font-weight-Medium);
    cursor: pointer;
}
.external-link-icon {
	margin-right: .5rem
}
.no-underline {
	text-decoration: none;
}

@media (min-width: 1800px) {
  .card-section {
    flex-wrap: no-wrap
  }
}
@media (max-width: 900px) {
  .card-section {
    flex-direction: column;
  }
}
</style>